import {AbstractQuoteService, quotesErrorSelector} from './abstract-quote.service';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {QuotesEntity} from '../model/quote-entity';
import {catchError, map, tap} from 'rxjs/operators';
import {Quote} from '../model/quote';
import {Observable} from 'rxjs';

@Injectable()
export class QuotesService extends AbstractQuoteService {
    constructor(private http: HttpClient) {
        super();
    }

    getQuotes(): Observable<Quote[]> {
        return this.http.get<QuotesEntity>(this.determineQuotesResourceUrl())
            .pipe(
                tap(response => console.log(response)),
                map(quotes => this.convertToQuotes(quotes)),
                catchError(err => quotesErrorSelector(err))
            );
    }
}
